import Dashboard from "./components/Dashboard";

function App() {
  return (
    <div>
      <h1 style={{ textAlign: "center" , fontSize: "40px", color : "RED", }}> 🏥 Heart Health Dashboard 🩺🩻</h1>
      <Dashboard />
    </div>
  );
}

export default App;